export enum ProcessRoutes {
  ROOT = "process",
  CLIENT_TYPE = "clientType",
  PERSONAL_DATA = "personalData",
  EDUCATION_QUESTION = "educationQuestion",
  EXTENDED_PERSONAL_DATA = "extendedPersonalData",
  EDUCATION_PROOF = "educationProof",
  ADDRESS_DATA = "addressData",
  IMPORTANT_QUESTIONS = "importantQuestions",
  LEAD_CLIENT_QUESTION = "leadClientQuestion",
  BENEFIT_ASSIGNMENT = "benefitAssignment",
  CONFIRMATION = "confirmation",
  IDENTIFICATION_ENTRY = "identificationEntry",
  IDENTIFICATION = "identification",
}

export enum EducationSteps {
  QUESTION = "question",
  PROOF = "proof",
}
